import compose from '../../../../lib/compose';
import connect from '../../../../store/connect';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import withRow from '../../../../components/grid/row/with-row';
import ReturnsNotification, { messageJsonToPropsJsonActions } from '../../../../components/message';

export const createReturnsNotification = featureName => {
  const mapStateToProps = ({ components: { [featureName]: returnsNotification } }) => ({
    ...messageJsonToPropsJsonActions(returnsNotification),
    className: 'returns-notification',
  });

  const enhance = compose(
    withFeatureFlag(featureName),
    withRow(featureName, 'container-returns-notification'),
    connect(mapStateToProps),
  );

  return enhance(ReturnsNotification);
};
